import { render, staticRenderFns } from "./PainelDocumentosTabela.vue?vue&type=template&id=f20772f6"
import script from "./PainelDocumentosTabela.vue?vue&type=script&lang=js"
export * from "./PainelDocumentosTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelDocumentosTabela.vue?vue&type=style&index=0&id=f20772f6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports